import { Image, Text, View } from 'components';
import Base, { Config } from 'components/scourge/Base';
import React from 'react';
import styles from './index.module.scss';

interface RechargeOption {
  id: number;
  value: number; // 积分
  price: string; // 价格
  gift: number; // 额外赠送
}

interface State {
  options: RechargeOption[];
  selectOptionIndex: number;
  requireScore: number;
  scores?: number;
}

export default class ScoresRecharge extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '积分充值'
  };

  public state: State = {
    options: [],
    requireScore: 0,
    selectOptionIndex: 0
  };

  public didMount() {
    this.fetchScores();
    this.fetchScoresConfig();
    this.fetchRechargeList();
  }

  public render() {
    const { options, selectOptionIndex, scores, requireScore } = this.state;

    return (
      <View className={styles.container}>
        <View className={styles.content}>
          <Text className={styles.scoresLabel}>当前积分</Text>
          <Text className={styles.scores}>{scores}</Text>
        </View>
        <View className={styles.body}>
          <View className={styles.options}>
            {options.map((option, index) => {
              const selected = index === selectOptionIndex;
              return (
                <View
                  key={index}
                  onClick={this.handleSelectOption.bind(this, index)}
                  className={this.cx(
                    styles.option,
                    selected && styles.selected
                  )}
                >
                  {selected && (
                    <Image
                      className={styles.selectedIcon}
                      src={this.assets.scourge.selected}
                    />
                  )}
                  <View className={styles.title}>
                    <Text className={styles.text}>{option.value}</Text>
                    <Text className={styles.unit}>积分</Text>
                  </View>
                  <Text className={styles.value}>
                    {Math.floor(Number(option.price))}
                  </Text>
                  <Text className={styles.unit}>元</Text>
                </View>
              );
            })}
          </View>
          <View className={styles.button} onClick={this.handlePurchase}>
            <Text className={styles.buttonText}>立即充值</Text>
          </View>
        </View>
        <View className={styles.tip}>
          <Text className={styles.text}>
            1、积分可用于购买提问、资料、会员等虚拟内容；
          </Text>
          <Text className={styles.text}>
            2、积分仅限苹果手机用户消费，安卓用户无需充值积分
          </Text>
          <Text className={styles.text}>
            3、积分为虚拟物品，充值后的积分不会过期，但无法提 现或转赠他人
          </Text>
        </View>
      </View>
    );
  }

  private handlePurchase = async () => {
    const response = await this.apiClient.base.purchaseScores({
      id: this.selectedOption.id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('充值成功');
        this.fetchScores();
      }
    });
  }

  private fetchScoresConfig = async () => {
    const { body } = await this.apiClient.base.scoresConfig();

    const requireScore = Number(
      body.find(
        item => item.category === 'resume' && item.name === 'call_dec_score'
      ).value
    );

    this.setState({
      requireScore
    });
  }

  private fetchScores = async () => {
    const { body } = await this.apiClient.base.account();

    this.setState({
      scores: body.score
    });
  }

  private fetchRechargeList = async () => {
    const { body: options } = await this.apiClient.base.scoresRechargeList();

    this.setState({
      options,
      selectOptionIndex:
        (options.find(option => option.selected !== 0) || {}).selected || 0
    });
  }

  private handleSelectOption = index => {
    this.setState({
      selectOptionIndex: index
    });
  }

  private get selectedOption() {
    const { selectOptionIndex, options } = this.state;

    return options[selectOptionIndex] || {};
  }
}
